import { useMemo } from 'react';
import { useMedia } from 'react-use';

// TODO should be common hook
export const useIwBreakPoints = () => {
  const isDesktop = useMedia('(min-width: 1200px)');
  const isTablet = useMedia('(min-width: 801px) and (max-width: 1199px)');
  const isMobile = useMedia('(max-width: 800px)');
  const isMobileXs = useMedia('(max-width: 390px)');

  return useMemo(
    () => ({
      isDesktop,
      isTablet,
      isMobile,
      isMobileXs,
    }),
    [isDesktop, isTablet, isMobile, isMobileXs],
  );
};
